import { AccountModule } from '@/core/modules/account/account.module'
import HealthCareIcon from '@assets/images/healthcare.svg?react'
import { Text } from '@atbay/component-lib'
import { HeaderTitleContainer } from './HeaderTitle.styles'
import { StyledArrowDown } from '@/ui/components/account-picker/index.styles'

const HeaderTitle = () => {
    const { currentAccount, accounts, expiredAccountsNames } = AccountModule.useStore()
    const shouldShowArrow = Object.values(accounts).length + expiredAccountsNames.length > 1

    return (
        <HeaderTitleContainer data-testid="account-picker-header-title">
            <HealthCareIcon />
            <Text textVariant="pri14R">{currentAccount?.company_name}</Text>
            {shouldShowArrow && <StyledArrowDown data-testid="account-picker-arrow"/>}
        </HeaderTitleContainer>
    )
}

export default HeaderTitle
